import { atom } from 'nanostores'
import { $isBoostingBannerDismissed } from './boosting-banner'

export const $isBoostingPacksOpen = atom<boolean>(false)

/** One-shot flag: true while the banner's fly-to-chip exit is deferred until
 *  the sheet closes. Set when the sheet is opened straight from a still-present
 *  banner (the user's first open) so the banner morphs into the top-nav chip
 *  as the sheet dismisses, instead of vanishing instantly on open. The banner
 *  consumes and clears it on sheet close. */
export const $boostingBannerFlyOnSheetClose = atom<boolean>(false)

export const openBoostingPacks = () => {
  // First open comes from the banner (the chip only exists post-dismissal).
  // Defer the banner's fly-to-chip hand-off to the sheet close instead of
  // dismissing instantly, so the entry animation plays on the way out. Opens
  // from the chip (banner already dismissed) have nothing to defer.
  if (!$isBoostingBannerDismissed.get()) {
    $boostingBannerFlyOnSheetClose.set(true)
  }
  $isBoostingPacksOpen.set(true)
}

export const closeBoostingPacks = () => {
  $isBoostingPacksOpen.set(false)
}
